import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumericFormat } from "react-number-format";
import Link from "next/link";
import { usePlausible } from "next-plausible";
import AnimateHeight from "react-animate-height";
import { FormWrapper, CauseAreaTitle, CauseAreaContext, TotalSumWrapper, SumWrapper, SumButtonsWrapper, InputList, OrganizationInputWrapper, OperationsPercentageInputWrapper } from "../AmountPane.style";
import { getCauseAreaIconById } from "../SelectionPane.style";
import { CauseArea } from "../../../types/CauseArea";
import { ShareType } from "../../../types/Enums";
import { setCauseAreaAmount, setOrgAmount, setCauseAreaDistributionType, setOperationsPercentageModeByCauseArea, setOperationsPercentageByCauseArea, setShowAllOrganizations, setHasManuallyEditedPrefilledOrgAmount } from "../../../store/donation/actions";
import { thousandize } from "../../../../../../../util/formatting";
import { EffektButton, EffektButtonVariant } from "../../../../EffektButton/EffektButton";
import { RadioButtonGroup } from "../../../../RadioButton/RadioButtonGroup";
import { CheckBoxWrapper, HiddenCheckBox } from "../Forms.style";
import { CustomCheckBox } from "../DonorPane/CustomCheckBox";
import { OperationsConfig, CauseAreaDisplayConfig, SmartDistributionContext } from "../../../types/WidgetProps";
import { CauseAreaRollout } from "../../shared/CauseAreaRollout/CauseAreaRollout";
import { splitOperationsLabelTemplate } from "../../../utils/operationsLabel";
import { useIsMobile } from "../../../../../../../hooks/useIsMobile";
interface CauseAreaFormProps {
  causeArea: CauseArea;
  isSingleSelection: boolean;
  suggestedSums: Array<{
    amount: number;
    subtext?: string;
  }>;
  causeAreaAmounts: Record<number, number>;
  orgAmounts: Record<number, number>;
  causeAreaDistributionType: Record<number, ShareType>;
  showOperationsOption?: boolean;
  operationsConfig?: OperationsConfig;
  causeAreaDisplayConfig?: CauseAreaDisplayConfig;
  smartDistributionContext: SmartDistributionContext;
}
export const CauseAreaForm: React.FC<CauseAreaFormProps> = t0 => {
  const $ = _c(91);
  const {
    causeArea,
    isSingleSelection,
    suggestedSums,
    causeAreaAmounts,
    orgAmounts,
    causeAreaDistributionType,
    showOperationsOption: t1,
    operationsConfig,
    causeAreaDisplayConfig,
    smartDistributionContext
  } = t0;
  const showOperationsOption = t1 === undefined ? false : t1;
  const dispatch = useDispatch();
  const plausible = usePlausible();
  const isMobile = useIsMobile();
  const hasSingleOrg = causeArea.organizations.length <= 1;
  const isOtherCauseArea = causeArea.id === 5;
  const hideDistributionToggle = hasSingleOrg || isOtherCauseArea;
  const currentCauseAreaAmount = causeAreaAmounts[causeArea.id] || 0;
  const {
    operationsPercentageModeByCauseArea: t2,
    operationsPercentageByCauseArea: t3,
    operationsConfig: stateConfig,
    prefilledShares: t4,
    showAllOrganizations: t5,
    hasManuallyEditedPrefilledOrgAmount: t6
  } = useSelector(_temp);
  let t7;
  if ($[0] !== t2) {
    t7 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const operationsPercentageModeByCauseArea = t7;
  let t8;
  if ($[2] !== t3) {
    t8 = t3 === undefined ? {} : t3;
    $[2] = t3;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const operationsPercentageByCauseArea = t8;
  const prefilledShares = t4 === undefined ? null : t4;
  const showAllOrganizations = t5 === undefined ? false : t5;
  const hasManuallyEditedPrefilledOrgAmount = t6 === undefined ? false : t6;
  let T0;
  let currentPercentage;
  let handleCutToggle;
  let handlePercentageChange;
  let isOperationsEnabled;
  let operationsLabelPrefix;
  let operationsLabelSuffix;
  let t10;
  let t11;
  let t9;
  if ($[4] !== causeArea.id || $[5] !== causeArea.name || $[6] !== causeArea.organizations || $[7] !== causeArea.widgetDisplayName || $[8] !== causeAreaAmounts || $[9] !== causeAreaDisplayConfig || $[10] !== causeAreaDistributionType || $[11] !== currentCauseAreaAmount || $[12] !== dispatch || $[13] !== hasManuallyEditedPrefilledOrgAmount || $[14] !== hasSingleOrg || $[15] !== hideDistributionToggle || $[16] !== isMobile || $[17] !== isSingleSelection || $[18] !== operationsConfig || $[19] !== operationsPercentageByCauseArea || $[20] !== operationsPercentageModeByCauseArea || $[21] !== orgAmounts || $[22] !== plausible || $[23] !== prefilledShares || $[24] !== showAllOrganizations || $[25] !== smartDistributionContext || $[26] !== stateConfig || $[27] !== suggestedSums) {
    const activeOrganizations = causeArea.organizations.filter(_temp2).sort(_temp3);
    let t12;
    if ($[38] !== prefilledShares) {
      t12 = organization_0 => prefilledShares?.[organization_0.id] !== undefined;
      $[38] = prefilledShares;
      $[39] = t12;
    } else {
      t12 = $[39];
    }
    const hasPrefilledOrganizations = activeOrganizations.some(t12);
    const isTrackingPrefilledShares = hasPrefilledOrganizations && !hasManuallyEditedPrefilledOrgAmount;
    const visibleOrganizations = hasPrefilledOrganizations && !showAllOrganizations ? activeOrganizations.filter(organization_1 => prefilledShares?.[organization_1.id] !== undefined) : activeOrganizations;
    const config = operationsConfig || stateConfig;
    const defaultPercentage = config?.defaultPercentage ?? 5;
    currentPercentage = operationsPercentageByCauseArea[causeArea.id] ?? defaultPercentage;
    const t13 = config?.operations_label_template;
    let t14;
    if ($[40] !== t13) {
      t14 = splitOperationsLabelTemplate(t13);
      $[40] = t13;
      $[41] = t14;
    } else {
      t14 = $[41];
    }
    ({
      prefix: operationsLabelPrefix,
      suffix: operationsLabelSuffix
    } = t14);
    isOperationsEnabled = operationsPercentageModeByCauseArea[causeArea.id] ?? false;
    const inputValue = currentCauseAreaAmount;
    let t15;
    if ($[42] !== causeArea.id || $[43] !== dispatch) {
      t15 = checked => {
        dispatch(setOperationsPercentageModeByCauseArea(causeArea.id, checked));
      };
      $[42] = causeArea.id;
      $[43] = dispatch;
      $[44] = t15;
    } else {
      t15 = $[44];
    }
    handleCutToggle = t15;
    let t16;
    if ($[45] !== causeArea.id || $[46] !== dispatch) {
      t16 = (values, sourceInfo) => {
        if (sourceInfo.source !== "event") {
          return;
        }
        const v = values.floatValue === undefined ? 0 : values.floatValue;
        const limitedPercentage = Math.min(Math.max(v, 0), 100);
        dispatch(setOperationsPercentageByCauseArea(causeArea.id, limitedPercentage));
      };
      $[45] = causeArea.id;
      $[46] = dispatch;
      $[47] = t16;
    } else {
      t16 = $[47];
    }
    handlePercentageChange = t16;
    const setTrackedOrganizationAmounts = amount => {
      if (!isTrackingPrefilledShares || !prefilledShares) {
        return;
      }
      causeArea.organizations.forEach(organization_2 => {
        const share = prefilledShares[organization_2.id];
        if (share !== undefined) {
          dispatch(setOrgAmount(organization_2.id, Math.round(share / 100 * amount)));
        }
      });
    };
    let t17;
    if ($[48] !== causeArea.id || $[49] !== causeArea.organizations[0] || $[50] !== dispatch || $[51] !== hasSingleOrg || $[52] !== setTrackedOrganizationAmounts) {
      t17 = (values_0, sourceInfo_0) => {
        if (sourceInfo_0.source !== "event") {
          return;
        }
        const v_0 = values_0.floatValue === undefined ? 0 : values_0.floatValue;
        dispatch(setCauseAreaAmount(causeArea.id, v_0));
        if (hasSingleOrg) {
          dispatch(setOrgAmount(causeArea.organizations[0].id, v_0));
        } else {
          setTrackedOrganizationAmounts(v_0);
        }
      };
      $[48] = causeArea.id;
      $[49] = causeArea.organizations[0];
      $[50] = dispatch;
      $[51] = hasSingleOrg;
      $[52] = setTrackedOrganizationAmounts;
      $[53] = t17;
    } else {
      t17 = $[53];
    }
    const handleAmountChange = t17;
    let t18;
    if ($[54] !== causeArea.id || $[55] !== causeArea.organizations[0] || $[56] !== dispatch || $[57] !== hasSingleOrg || $[58] !== plausible || $[59] !== setTrackedOrganizationAmounts) {
      t18 = amount_0 => {
        plausible("SelectSuggestedSum", {
          props: {
            sum: amount_0
          }
        });
        dispatch(setCauseAreaAmount(causeArea.id, amount_0));
        if (hasSingleOrg) {
          dispatch(setOrgAmount(causeArea.organizations[0].id, amount_0));
        } else {
          setTrackedOrganizationAmounts(amount_0);
        }
      };
      $[54] = causeArea.id;
      $[55] = causeArea.organizations[0];
      $[56] = dispatch;
      $[57] = hasSingleOrg;
      $[58] = plausible;
      $[59] = setTrackedOrganizationAmounts;
      $[60] = t18;
    } else {
      t18 = $[60];
    }
    const handleSuggestedSumClick = t18;
    T0 = FormWrapper;
    t9 = causeArea.id;
    let t19;
    if ($[61] !== causeArea.id) {
      t19 = getCauseAreaIconById(causeArea.id);
      $[61] = causeArea.id;
      $[62] = t19;
    } else {
      t19 = $[62];
    }
    const t20 = causeArea.widgetDisplayName || causeArea.name;
    let t21;
    if ($[63] !== t19 || $[64] !== t20) {
      t21 = <CauseAreaTitle>{t19}{t20}</CauseAreaTitle>;
      $[63] = t19;
      $[64] = t20;
      $[65] = t21;
    } else {
      t21 = $[65];
    }
    let t22;
    if ($[66] !== causeArea.id || $[67] !== causeAreaDisplayConfig) {
      t22 = getCauseAreaContext(causeArea.id, causeAreaDisplayConfig) && <CauseAreaContext>{getCauseAreaContext(causeArea.id, causeAreaDisplayConfig)}</CauseAreaContext>;
      $[66] = causeArea.id;
      $[67] = causeAreaDisplayConfig;
      $[68] = t22;
    } else {
      t22 = $[68];
    }
    if ($[69] !== t21 || $[70] !== t22) {
      t10 = <div>{t21}{t22}</div>;
      $[69] = t21;
      $[70] = t22;
      $[71] = t10;
    } else {
      t10 = $[71];
    }
    t11 = <div>{hideDistributionToggle ? <TotalSumWrapper>{isSingleSelection && <SumButtonsWrapper>{suggestedSums.map(suggested => <div key={suggested.amount}><EffektButton variant={EffektButtonVariant.SECONDARY} selected={inputValue === suggested.amount} onClick={() => handleSuggestedSumClick(suggested.amount)} noMinWidth={true} data-cy={`suggested-sum-${causeArea.id}-${suggested.amount}`}>{`${suggested.amount ? thousandize(suggested.amount) : "-"} kr`}</EffektButton>{suggested.subtext && <i>{suggested.subtext}</i>}</div>)}</SumButtonsWrapper>}<SumWrapper><span><NumericFormat name={`sum-${causeArea.id}`} thousandSeparator=" " allowNegative={false} decimalScale={0} type="tel" placeholder="0" value={inputValue > 0 ? inputValue : ""} autoComplete="off" data-cy={`donation-sum-input-${causeArea.id}`} onValueChange={handleAmountChange} /></span></SumWrapper></TotalSumWrapper> : <><AnimateHeight height={causeAreaDistributionType[causeArea.id] === ShareType.STANDARD || causeAreaDistributionType[causeArea.id] === undefined ? "auto" : 0} animateOpacity={true} duration={300}><div style={{
            paddingBottom: "30px"
          }}><TotalSumWrapper>{isSingleSelection && <SumButtonsWrapper>{suggestedSums.map(suggested_0 => <div key={suggested_0.amount}><EffektButton variant={EffektButtonVariant.SECONDARY} selected={inputValue === suggested_0.amount} onClick={() => handleSuggestedSumClick(suggested_0.amount)} noMinWidth={true} data-cy={`suggested-sum-${causeArea.id}-${suggested_0.amount}`}>{`${suggested_0.amount ? thousandize(suggested_0.amount) : "-"} kr`}</EffektButton>{suggested_0.subtext && <i>{suggested_0.subtext}</i>}</div>)}</SumButtonsWrapper>}<SumWrapper><span><NumericFormat name={`sum-${causeArea.id}`} type="tel" placeholder="0" thousandSeparator=" " value={inputValue > 0 ? inputValue : ""} allowNegative={false} step={1} decimalScale={0} autoComplete="off" data-cy={`donation-sum-input-${causeArea.id}`} onValueChange={handleAmountChange} /></span></SumWrapper></TotalSumWrapper></div></AnimateHeight><RadioButtonGroup options={[{
          title: smartDistributionContext.smart_distribution_radiobutton_text,
          value: ShareType.STANDARD,
          data_cy: `radio-smart-share-${causeArea.id}`
        }, {
          title: smartDistributionContext.custom_distribution_radiobutton_text,
          value: ShareType.CUSTOM,
          data_cy: `radio-custom-share-${causeArea.id}`,
          content: <InputList>{visibleOrganizations.map(org => <OrganizationInputWrapper key={org.id}><Link href={org.informationUrl || "#"} target={isMobile ? "_blank" : undefined} rel={isMobile ? "noopener noreferrer" : undefined}>{org.widgetDisplayName || org.name}</Link><span><NumericFormat id={`org-${org.id}`} aria-label={org.widgetDisplayName || org.name} type="tel" placeholder="0" value={orgAmounts[org.id] || ""} step={1} decimalScale={0} allowNegative={false} thousandSeparator=" " autoComplete="off" data-cy={`org-${org.id}`} onValueChange={(values_1, sourceInfo_1) => {
                  if (sourceInfo_1.source !== "event") {
                    return;
                  }
                  const v_1 = values_1.floatValue === undefined ? 0 : values_1.floatValue;
                  if (prefilledShares?.[org.id] !== undefined) {
                    dispatch(setHasManuallyEditedPrefilledOrgAmount(true));
                  }
                  dispatch(setOrgAmount(org.id, v_1));
                }} /></span></OrganizationInputWrapper>)}{hasPrefilledOrganizations && !showAllOrganizations && <EffektButton variant={EffektButtonVariant.SECONDARY} onClick={() => dispatch(setShowAllOrganizations(true))} data-cy="show-all-organizations-button">{smartDistributionContext.show_all_organizations_text} ↓</EffektButton>}</InputList>
        }]} selected={causeAreaDistributionType[causeArea.id] ?? ShareType.STANDARD} onSelect={val => {
          dispatch(setCauseAreaDistributionType(causeArea.id, val));
          if (val === ShareType.CUSTOM) {
            const hasSetOrgAmounts = Object.entries(orgAmounts).filter(t23 => {
              const [key, value] = t23;
              const orgId = parseInt(key);
              return value > 0 && causeArea.organizations.some(org_0 => org_0.id === orgId);
            }).length > 0;
            if (!hasSetOrgAmounts) {
              const causeAreaAmount = causeAreaAmounts[causeArea.id] || 0;
              for (const org_1 of causeArea.organizations) {
                if (!org_1.standardShare) {
                  continue;
                }
                const orgShare = Math.round(org_1.standardShare / 100 * causeAreaAmount);
                dispatch(setOrgAmount(org_1.id, orgShare));
              }
            }
          }
        }} /></>}</div>;
    $[4] = causeArea.id;
    $[5] = causeArea.name;
    $[6] = causeArea.organizations;
    $[7] = causeArea.widgetDisplayName;
    $[8] = causeAreaAmounts;
    $[9] = causeAreaDisplayConfig;
    $[10] = causeAreaDistributionType;
    $[11] = currentCauseAreaAmount;
    $[12] = dispatch;
    $[13] = hasManuallyEditedPrefilledOrgAmount;
    $[14] = hasSingleOrg;
    $[15] = hideDistributionToggle;
    $[16] = isMobile;
    $[17] = isSingleSelection;
    $[18] = operationsConfig;
    $[19] = operationsPercentageByCauseArea;
    $[20] = operationsPercentageModeByCauseArea;
    $[21] = orgAmounts;
    $[22] = plausible;
    $[23] = prefilledShares;
    $[24] = showAllOrganizations;
    $[25] = smartDistributionContext;
    $[26] = stateConfig;
    $[27] = suggestedSums;
    $[28] = T0;
    $[29] = currentPercentage;
    $[30] = handleCutToggle;
    $[31] = handlePercentageChange;
    $[32] = isOperationsEnabled;
    $[33] = operationsLabelPrefix;
    $[34] = operationsLabelSuffix;
    $[35] = t10;
    $[36] = t11;
    $[37] = t9;
  } else {
    T0 = $[28];
    currentPercentage = $[29];
    handleCutToggle = $[30];
    handlePercentageChange = $[31];
    isOperationsEnabled = $[32];
    operationsLabelPrefix = $[33];
    operationsLabelSuffix = $[34];
    t10 = $[35];
    t11 = $[36];
    t9 = $[37];
  }
  let t12;
  if ($[72] !== causeArea.id || $[73] !== currentPercentage || $[74] !== handleCutToggle || $[75] !== handlePercentageChange || $[76] !== isOperationsEnabled || $[77] !== operationsLabelPrefix || $[78] !== operationsLabelSuffix || $[79] !== showOperationsOption) {
    t12 = showOperationsOption && <div><div style={{
        display: "flex",
        alignItems: "center",
        gap: "10px"
      }}><CheckBoxWrapper><HiddenCheckBox type="checkbox" checked={isOperationsEnabled} onChange={e => handleCutToggle(e.target.checked)} data-cy={`cut-checkbox-${causeArea.id}`} /><CustomCheckBox checked={isOperationsEnabled} label="" /></CheckBoxWrapper><OperationsPercentageInputWrapper>{operationsLabelPrefix && <span>{operationsLabelPrefix}</span>}<span><NumericFormat name={`percentage-cut-${causeArea.id}`} allowNegative={false} decimalScale={1} max={100} type="tel" placeholder="5" value={currentPercentage} autoComplete="off" data-cy={`percentage-cut-input-${causeArea.id}`} onValueChange={handlePercentageChange} disabled={!isOperationsEnabled} /></span>{operationsLabelSuffix && <span>{operationsLabelSuffix}</span>}</OperationsPercentageInputWrapper></div></div>;
    $[72] = causeArea.id;
    $[73] = currentPercentage;
    $[74] = handleCutToggle;
    $[75] = handlePercentageChange;
    $[76] = isOperationsEnabled;
    $[77] = operationsLabelPrefix;
    $[78] = operationsLabelSuffix;
    $[79] = showOperationsOption;
    $[80] = t12;
  } else {
    t12 = $[80];
  }
  let t13;
  if ($[81] !== causeArea.id || $[82] !== causeAreaDisplayConfig) {
    t13 = <CauseAreaRollout causeAreaId={causeArea.id} config={causeAreaDisplayConfig} />;
    $[81] = causeArea.id;
    $[82] = causeAreaDisplayConfig;
    $[83] = t13;
  } else {
    t13 = $[83];
  }
  let t14;
  if ($[84] !== T0 || $[85] !== t10 || $[86] !== t11 || $[87] !== t12 || $[88] !== t13 || $[89] !== t9) {
    t14 = <T0 key={t9}>{t10}{t11}{t12}{t13}</T0>;
    $[84] = T0;
    $[85] = t10;
    $[86] = t11;
    $[87] = t12;
    $[88] = t13;
    $[89] = t9;
    $[90] = t14;
  } else {
    t14 = $[90];
  }
  return t14;
};
const getCauseAreaContext = (id: number, config?: CauseAreaDisplayConfig) => {
  const context = config?.cause_area_contexts?.find(c => c.cause_area_id === id);
  return context?.context_text || null;
};
function _temp(state) {
  return state.donation;
}
function _temp2(organization) {
  return organization.isActive;
}
function _temp3(first, second) {
  return first.ordering - second.ordering;
}